import React from "react"
import moment from 'moment';
import { FolderIcon } from './Icon';
import { ImageView } from "./ImageView";
import { resolveEntityRowDisplay } from './utils';

const formatFileSize = (bytes) => {
    if (bytes == null || isNaN(bytes)) return null;
    if (bytes === 0) return '0 B';
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1) + ' ' + units[i];
};

const formatDate = (date) => {
    if (!date) return null;
    return moment(date).format('M/D/YYYY');
};

export const CardTable = ({ dataSource, selectedRowKeys, children, onRow, onDropOnFolder, isSystemReadonly, entityFilter }) => {

    // R1：System 子树（全局模式）只读——不能作为拖放目标，其中的文件也不能拖出
    const isReadonlyNode = (item) => typeof isSystemReadonly === 'function' && isSystemReadonly(item);

    const handleDragStart = (e, item) => {
        e.dataTransfer.setData('text/plain', JSON.stringify({ key: item.key, id: item.id, name: item.name, isFolder: item.isFolder }));
        e.dataTransfer.effectAllowed = 'move';
        e.currentTarget.classList.add('file-dragging');
    };

    const handleDragEnd = (e) => {
        e.currentTarget.classList.remove('file-dragging');
    };

    const handleDragOverFolder = (e, item) => {
        if (!item.isFolder || item.isSystem || isReadonlyNode(item)) return;
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        e.currentTarget.classList.add('folder-drop-target');
    };

    const handleDragLeaveFolder = (e) => {
        e.currentTarget.classList.remove('folder-drop-target');
    };

    const handleDropOnFolder = (e, item) => {
        e.preventDefault();
        e.currentTarget.classList.remove('folder-drop-target');
        if (isReadonlyNode(item)) return;
        try {
            const data = JSON.parse(e.dataTransfer.getData('text/plain'));
            if (data && !data.isFolder && data.key !== item.key && onDropOnFolder) {
                onDropOnFolder(data, item);
            }
        } catch (err) {
            // ignore parse errors
        }
    };

    const getMeta = (item) => {
        if (item.isFolder) {
            const count = item.nodes?.length ?? 0;
            if (count === 0) return 'Empty folder';
            return `${count} item${count !== 1 ? 's' : ''}`;
        }
        const parts = [];
        const date = formatDate(item.modified_date || item.created_date);
        if (date) parts.push(date);
        const size = formatFileSize(item.size);
        if (size) parts.push(size);
        return parts.join('  ·  ');
    };

    return (
        <div className="file-management-cards">
            {dataSource.length === 0 ? (
                <div className="cards-empty-state">
                    {entityFilter ? 'No files found for this filter.' : 'No files found'}
                </div>
            ) : dataSource.map(item => {
                const isSelected = !!selectedRowKeys.find(i => i.key === item.key)
                const meta = getMeta(item);
                // 过滤结果里的 EQ-xx / WO-xx 目录：主标题实体名 + 灰字编号
                const display = resolveEntityRowDisplay(entityFilter, item);
                const primary = display?.primary || item.name || item.title;
                return (
                    <div
                        key={item.key}
                        className={`file-card${isSelected ? ' file-card-selected' : ''}`}
                        draggable={!item.isFolder && !item.isSystem && !isReadonlyNode(item)}
                        onDragStart={(e) => handleDragStart(e, item)}
                        onDragEnd={handleDragEnd}
                        onDragOver={(e) => handleDragOverFolder(e, item)}
                        onDragLeave={handleDragLeaveFolder}
                        onDrop={(e) => handleDropOnFolder(e, item)}
                        onDoubleClick={(e) => {
                            onRow(item).onDoubleClick(e)
                        }}
                        onClick={(e) => {
                            onRow(item).onClick(e)
                        }}
                        onContextMenu={(e) => {
                            onRow(item).onContextMenu(e)
                        }}
                    >
                        <div className="card-icon">
                            {item.isFolder ? (
                                <FolderIcon isOpen={false} isSystem={item.isSystem} ischecked={isSelected} size={52} />
                            ) : (
                                <ImageView item={item} isSelected={isSelected} />
                            )}
                        </div>
                        <div className={`card-name${display ? ' card-name-single' : ''}`} title={primary}>
                            {primary}
                        </div>
                        {display?.secondary ? (
                            <div className="card-name-sub" title={display.secondary}>{display.secondary}</div>
                        ) : null}
                        {meta && <div className="card-meta" title={meta}>{meta}</div>}
                    </div>
                )
            })}
        </div>
    )
}